export default __webpack_public_path__ + "assets/webgl/picking.3e4169db.glb";